import * as React from 'react';
import { CollapsibleHead, CollapsibleContent} from 'react-collapsible-component'
import './Collapsible.css'
export default class Collapsible extends React.Component {
    render(){
        return (
            <div style={{marginTop:20}}>
                <CollapsibleHead className="question" > {this.props.question} </CollapsibleHead>
                <CollapsibleContent className="answer"> {this.props.content} <br />{this.props.extraContent} <br /> {this.props.extraExtraContent ? this.props.extraExtraContent : undefined}</CollapsibleContent>
                
            </div>  
           
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/Faqs/Collapsible.js